const store = {
    state:{
        headerHeight: 0,
        isIbeFixed: false,
        ibeScrollTop: 0,
        isIbeSticky: false,
    },
    getters:{
        headerHeight: state => state.headerHeight,
        isIbeFixed: state => state.isIbeFixed,
        ibeScrollTop: state => state.ibeScrollTop,
        isIbeSticky: state => state.isIbeSticky,
    },
    mutations:{
        updateHeaderHeight(state, payload){
            state.headerHeight = payload;
        },
        updateIsIbeFixed(state, payload){
            state.isIbeFixed = payload;
        },
        updateIbeScrollTop(state, payload){
            state.ibeScrollTop = payload;
        },
        updateIsIbeSticky(state, payload){
            state.isIbeSticky = payload;
        }
    }
}

export default store;